export default [
  {
    path: '/userrecordpage',
    name: '用户问诊记录',
    component: () => import('../page/surveyResult/signalRecordingList'),
  },
  {
    path: '/userfeedback',
    name: '用户反馈',
    component: () => import('../page/surveyResult/signalRecordingList/userFeedback')
  },
  {
    path: '/resultquerypage',
    name: '结果查询页',
    component: () => import('../page/surveyResult/signalResultQuery')
  },
  {
    path: '/resultdisplaypage',
    name: '结论页',
    component: () => import('../page/surveyResult/signalResultDisplay')
  },
  {
    path: '/showprescription',
    name: '处方',
    component: () => import('../page/surveyResult/signalResultDisplay/showPrescription/index')
  },
  {
    path: '/followupVisit',
    name: '回诊',
    component: () => import('../page/surveyResult/signalResultDisplay/showPrescription/followupVisit/index')
  },

]
